import cloneDeep from 'lodash/cloneDeep';
import { actionCreators } from 'react/api/actions/crud';
import { createIncludesTestTo } from 'react/utils/utils';

const formatRuleTypes = (ruleType, value) => (acc, rule) => {
  const fields = rule.fields.filter(field => field.ruleTypes.includes(ruleType));
  if (fields.length) {
    acc.items.push({
      'tag': 'optgroup',
      'attributes': {
        'label': Monet.I18n.getResourcesByKey(rule.label),
        'triggersToShow': rule.triggersToShow
      },
      'items': fields.map(field => {
        const fieldValue = field.attr || field.customAttr;
        const option = {
          'tag': 'option',
          'html': Monet.I18n.getResourcesByKey(field.label),
          'attributes': {
            'value': fieldValue,
            'type': field.type,
            'entity': field.entity || '',
            'column': field.column,
            'customAttr': field.customAttr
          },
        };
        if (value === fieldValue) {
          option.attributes.selected = 'selected';
        }
        return option;
      }),
    });
  }
  return acc;
};

const getSizeOptions = (value, prefix) => {
  const items = [
      {
        'tag': 'option',
        'html': Monet.Session.Configurations['size1Alias'],
        'attributes': {
          'value': `${prefix}Size1`
        }
      },
      {
        'tag': 'option',
        'html': Monet.Session.Configurations['size2Alias'],
        'attributes': {
          'value': `${prefix}Size2`
        }
      },
      {
        'tag': 'option',
        'html': Monet.Session.Configurations['size3Alias'],
        'attributes': {
          'value': `${prefix}Size3`
        }
      }
    ];
    return items.map(item => {
      if (value === item.attributes.value) {
        item.attributes.selected = 'selected';
      }
      return item;
    });
}

class ApplyRulePopup {
  constructor(
    data = {
      trigger: 'BEFORE',
      when: {
        value: '',
        label: '',
      },
      rules: new Map(),
    },
  ) {
    this.state = cloneDeep(data);
  }

  setRuleProperty(ruleId, key, value) {
    const rule = this.state.rules.get(ruleId) || {};
    rule[key] = value;
    this.state.rules.set(ruleId, { ...rule });
  }

  checkEmptyEventTrigger() {
    return this.state.when.value;
  }

  createModalContent(closeModalFn) {
    const popupElement = document.querySelector('#Survey .application-rules-modal .generic-modal__modal-body');

    if(popupElement) {

      const modalFormContent = document.createElement('div');
      const helper = new Monet.UI.Help(
        'SurveyApplyRules',
        Monet.I18n.getResourcesByKey('survey.userinterface.description'),
      );

      const closePopup = () => { closeModalFn() };

      const saveApplyRule = () => {
        const isValid = this.validatePopUp();

        if (isValid) {
          this.saveApplyRules();
          Greenmile.Survey.SurveyApplyRule.renderRulesList();

          globalStore.dispatch(
            actionCreators.invalidSubmitCustom({
              entity: "Survey",
              invalidSubmitCustom: false,
            })
          );

          closePopup();
        }
      };

      modalFormContent.id = 'SurveyApplyRules';
      modalFormContent.className = 'MonetUIModal MainFormLayout';
      modalFormContent.appendChild(Greenmile.Survey.Templates.SurveyApplyRulesTemplate());

      popupElement.appendChild(modalFormContent);

      this.sideBar = document.querySelector('#SurveyApplyRules .sidebar');
      this.formContent = document.querySelector('#SurveyApplyRules .formContent');

      const saveBtn = document.querySelector('#SurveyApplyRules #LinkFormSaveButton');
      const cancelBtn = document.querySelector('#SurveyApplyRules #LinkFormCancelButton');

      cancelBtn.addEventListener('click', closePopup);
      saveBtn.addEventListener('click', saveApplyRule.bind(this));
      this.formContent.querySelector('.buttonGroup').appendChild(helper.render());
      this.sideBar.querySelectorAll('.sidebar-item li').forEach(item => {
        this.addListenerRuleItems(item);
      });

      this.sideBar.querySelectorAll('.sidebar-item label').forEach(item => {
        item.addEventListener('click', this.toggleSidebarItems.bind(this));
      });

      if (this.state.when.value) {
        const item = this.sideBar.querySelector(`li[value="${this.state.when.value}"]`);
        item.classList.add('selected');

        this.blockSideBar();
      }

      if (this.state.rules.size) {
        this.state.rules.forEach((rule, ruleId) =>
          this.renderRuleDomLine(this.state.when, rule, ruleId)
        );
      } else if (this.state.when.value) {
        this.renderRuleDomLine(this.state.when);
      }

      this.handlerToInformTheRuleAndTheGroupInTitle();
      this.handleWhenSurveyReleasedOrClosed();

    } else {
      new Monet.Exception.ReturnError(this, "No modal to add form.")
        .console();
    }
  }


  toggleSidebarItems({ target }) {
    const ul = target.parentNode.querySelector('ul');
    const label = target;
    const setClassName = (state) =>
      [ul, label].forEach((el) => (el.className = state));

    if (ul.classList.contains('opened')) {
      setClassName('closed');
    } else {
      setClassName('opened');
    }
  }

  addListenerRuleItems(ruleItem) {
    ruleItem.addEventListener('click', ({ target }) => {
      const rules = this.formContent.querySelector('.rules');
      const sidebar = target.parentNode.parentNode.parentNode;
      sidebar.querySelectorAll('li').forEach(item => {
        item.classList.remove('selected');
      });
      target.classList.add('selected');
      if (rules) {
        rules.innerHTML = '';
        this.state.rules.clear();
      }
      this.state.when = {
        value: target.getAttribute('value'),
        label: target.innerText,
        ruleType: target.getAttribute('ruletype'),
      };
      this.renderRuleDomLine(this.state.when);
    });
  }

  renderOperatorList(fieldType, operatorValue) {
    const operators = Greenmile.Survey.SurveyApplyRule.operatorsByFieldType[fieldType].map(operator => {
      const data = Greenmile.Survey.SurveyApplyRule.operators[operator];
      const option = {
        'tag': 'option',
        'html': Monet.I18n.getResourcesByKey(data.label),
        'attributes': {
          'value': data.value,
        },
      };
      if (operatorValue === data.value) {
        option.attributes.selected = 'selected';
      }
      return option;
    });
    const whenList = {
      items: [
        {
          tag: 'div',
          attributes: {
            class: 'rule-line-item',
          },
          items: [
            {
              tag: 'select',
              items: [...operators],
            },
          ],
        },
      ],
    };
    return new Monet.UI.LayoutGenerator(whenList).render();
  }

  renderButtonsSection() {
    const buttonContainer = document.createElement('div');
    const buttonPlus = document.createElement('i');
    const buttonMinus = document.createElement('i');
    buttonPlus.className = 'fa fa-plus-circle';
    buttonMinus.className = 'fa fa-minus-circle';
    buttonPlus.addEventListener("click", () => {
      const sideBarItemSelectedEl = this.sideBar.querySelector(".sidebar-item li.selected");
      this.renderRuleDomLine({
        ruleType: sideBarItemSelectedEl.getAttribute("ruletype"),
        value: sideBarItemSelectedEl.getAttribute("value"),
      });
    });
    buttonMinus.addEventListener('click', () => {
      const ruleLine = buttonMinus.parentNode.parentNode;
      this.state.rules.delete(ruleLine.id);
      ruleLine.parentNode.removeChild(ruleLine);
    });
    buttonContainer.className = 'rule-line-item rule-line__buttons';
    buttonContainer.appendChild(buttonMinus);
    buttonContainer.appendChild(buttonPlus);
    return buttonContainer;
  }

  renderOperatorSelector(type, operator, ruleLineId) {
    const operatorSelect = this.renderOperatorList(type, operator);
    operatorSelect.querySelector('select').addEventListener('change', this.changeFieldByOperator.bind(this));
    this.setRuleProperty(ruleLineId, 'operator', operatorSelect.querySelector('option:checked').value);
    return operatorSelect;
  }

  renderField(field, operator, value, ruleLineId) {
    const fieldContainer = document.createElement('div');
    const fieldEl = this.createField(field, operator, value);
    this.setRuleProperty(ruleLineId, 'fieldEl', fieldEl);
    fieldContainer.classList.add('rule-line-item');
    fieldContainer.classList.add('field');
    fieldContainer.appendChild(fieldEl.rootEl);
    return fieldContainer;
  }

  changeFieldByOperator({ target }) {
    const optionSelected = target[target.selectedIndex];
    const ruleLine = target.parentNode.parentNode;
    const operator = optionSelected.getAttribute('value');
    const rule = this.state.rules.get(ruleLine.id);
    const changeToLookup =
      (rule.operator === 'in' || rule.operator === 'notIn') && (operator === 'eq' || operator === 'ne');
    const changeToLookupList =
      (rule.operator === 'eq' || rule.operator === 'ne') && (operator === 'in' || operator === 'notIn');
    const {
      field: { type },
    } = rule;
    if (type === 'lookup' && (changeToLookupList || changeToLookup)) {
      ruleLine.removeChild(ruleLine.querySelector('.rule-line-item.field'));
      ruleLine.insertBefore(
        this.renderField(rule.field, operator, null, ruleLine.id),
        ruleLine.querySelector('.rule-line-item:last-child'),
      );
    }
    this.setRuleProperty(ruleLine.id, 'operator', operator);
  }

  onChangeRule({ srcElement }) {
    const ruleLine = srcElement.parentNode.parentNode;
    const optionSelected = srcElement[srcElement.selectedIndex];
    const customAttr = optionSelected.getAttribute('customAttr');
    const field = {
      attr: optionSelected.getAttribute('value'),
      type: optionSelected.getAttribute('type'),
      customAttr: (customAttr !== 'undefined') ? customAttr : '',
      entity: optionSelected.getAttribute('entity'),
      column: optionSelected.getAttribute('column'),
    };
    this.setRuleProperty(ruleLine.id, 'field', field);
    ruleLine.querySelectorAll('.rule-line-item:not(:first-child)').forEach(line => {
      ruleLine.removeChild(line);
    });
    if (!field.customAttr) {
      ruleLine.appendChild(this.renderOperatorSelector(field.type, null, ruleLine.id));
      ruleLine.appendChild(this.renderField(field, null, null, ruleLine.id));
    } else {
      const content = this.renderCustomItems(field, null, ruleLine.id);
      if (content) {
        ruleLine.appendChild(content);
      }
    }
    ruleLine.appendChild(this.renderButtonsSection());
  }

  renderCustomItems(field, value, ruleLineId) {
    let options = [];
    switch (field.customAttr) {
      case 'Order.delivered':
      case 'Order.canceled':
      case 'Order.partialDelivery':
        options = getSizeOptions(value, 'actual');
        break;
      case 'Order.damaged':
        options = getSizeOptions(value, 'damaged');
        break;
      default:
        break;
    }
    if (options.length) {
      const content = new Monet.UI.LayoutGenerator({
        items: [
          {
            tag: 'div',
            attributes: {
              class: 'rule-line-item',
            },
            items: [
              {
                tag: 'select',
                items: options,
              },
            ],
          },
        ],
      }).render();
      const setValueToCustomItem = ({ target }) => {
        this.setRuleProperty(ruleLineId, 'value', target.querySelector('option:checked').value);
      }
      setValueToCustomItem({ target: content });
      content.querySelector('select').addEventListener('change', setValueToCustomItem.bind(this));
      return content;
    }
    return null;
  }

  renderRuleDomLine({ ruleType, value: ruleValue }, rule, ruleId) {
    const ruleLine = document.createElement('div');
    const ruleSelectContainer = document.createElement('div');
    const selectFilters = document.createElement('select');
    const { rules } = Greenmile.Survey.SurveyApplyRule;
    ruleLine.id = ruleId || uuid();
    ruleLine.className = 'rule-line';
    ruleSelectContainer.className = 'rule-line-item';
    const ruleList = rules.reduce(formatRuleTypes(ruleType, rule?.field?.attr || rule?.field?.customAttr), {
      items: [
        {
          'tag': 'option',
          'html': Monet.I18n.getResourcesByKey('surveyApplyRule.defaultOption'),
        },
      ],
    });

    const ruleListChecked = this.checkRuleListWithTriggersToShow(ruleList, ruleValue);

    selectFilters.appendChild(new Monet.UI.LayoutGenerator(ruleListChecked).render());
    selectFilters.addEventListener('change', this.onChangeRule.bind(this));
    ruleSelectContainer.appendChild(selectFilters);
    ruleLine.appendChild(ruleSelectContainer);

    if (rule?.field) {
      if (!rule.field.customAttr) {
        ruleLine.appendChild(this.renderOperatorSelector(rule.field?.type, rule.operator, ruleLine.id));
        ruleLine.appendChild(this.renderField(rule.field, rule.operator, rule.value, ruleLine.id));
      } else {
        const content = this.renderCustomItems(rule.field, rule.value, ruleLine.id);
        if (content) {
          ruleLine.appendChild(content);
        }
      }
      ruleLine.appendChild(this.renderButtonsSection());
    }

    this.formContent.querySelector('.rules-group .rules').appendChild(ruleLine);
  }

  createField(selectedField, operator, value) {
    let field = null;

    switch (selectedField.type) {
      case 'lookup':
        const nameField = selectedField.attr.replace(/\./g, '_');
        const nameFieldFormatted = nameField[0].toUpperCase() + nameField.substring(1) + '_' + new Date().getTime();
        const nameSpace = 'Survey' + 'Lookup' + nameFieldFormatted;

        if (operator === 'in' || operator === 'notIn') {
          field = new Monet.UI.Fields.PowerLookupList();

          field.setCallbackAfterFilter(this.hideDeleteButtonsFromLookupList);
        } else {
          field = new Monet.UI.Fields.PowerLookup();
        }

        field.setId(nameFieldFormatted);
        field.setNameSpace(nameSpace);
        field.setBaseSelector('#' + nameFieldFormatted);
        field.setMandatory(false);
        field.setDisplayKey(selectedField.column);
        field.setLookUpEntity(selectedField.entity);
        field.setInputName(selectedField.attr);
        field.setTextLabel(Monet.I18n.getResourcesByKey(selectedField.label));

        field.render();

        break;
      case 'number':
        field = new Monet.UI.Fields.Decimal();
        field.render();
        field.setId(selectedField.attr);
        field.setTextLabel(Monet.I18n.getResourcesByKey(selectedField.label));
        field.setInputName(selectedField.attr);

        break;
      case 'checkbox':
        field = new Monet.UI.Fields.Base();
        field.render();
        field.label.style.marginLeft = '211px';
        field.label.style.display = 'inline-block';
        field.setId(selectedField.attr);
        field.setInputName(selectedField.attr);

        break;
      default:
        field = new Monet.UI.Fields.TextField();
        field.render();
        field.setTextLabel(Monet.I18n.getResourcesByKey(selectedField.label));
        field.setInputName(selectedField.attr);
        field.setId(selectedField.attr);
    }

    if (value) {
      field.setValue(value);
    }

    return field;
  }

  checkDuplicateRule() {
    return Greenmile.Survey.SurveyApplyRule.data.filter(
      item => item.when.value === this.state.when.value && !this.state.id,
    ).length;
  }

  saveApplyRules() {
    const { rules, when, id } = this.state;
    const rulesFormmated = new Map();
    rules.forEach((rule, index) => {
      let value = '';
      if (rule.fieldEl) {
        value = (rule.field.type === 'lookup') ? rule.fieldEl.getFullValue() : rule.fieldEl.getValue();
      } else {
        value = rule.value;
      }
      rulesFormmated.set(index, {
        operator: rule.operator,
        field: rule.field,
        value,
        isNew: rule.isNew
      });
    });
    if (id) {
      Greenmile.Survey.SurveyApplyRule.data = Greenmile.Survey.SurveyApplyRule.data.map(rule => {
        if (rule.id === id) {
          return {
            id,
            when,
            rules: rulesFormmated,
            isNew: rule.isNew || false
          };
        }
        return rule;
      });
    } else {
      Greenmile.Survey.SurveyApplyRule.data.push({
        id: uuid(),
        when,
        rules: rulesFormmated,
        isNew: true
      });
    }
  }

  handleWhenSurveyReleasedOrClosed() {
    const { releasedDate, closedDate  } = Greenmile.Survey.Builder;

    const hideAddRemoveFilterFieldsButtons = formModalContent => {
      formModalContent
        .querySelectorAll('.rules-group .rule-line__buttons')
        .forEach(buttonsContainer => buttonsContainer.classList.add('display-none'));
    };

    const disableFields = formModalContent => {
      formModalContent
        .querySelectorAll('.rules-group select')
        .forEach(selectField => selectField.setAttribute('disabled', 'disabled'));

      formModalContent
        .querySelectorAll('.rules-group input')
        .forEach(selectField => selectField.setAttribute('disabled', 'disabled'));
    };

    const disableSaveButton = formModalContent => {
      const saveButtonEl = formModalContent.querySelector('.buttonGroup #LinkFormSaveButton');
      saveButtonEl && saveButtonEl.setAttribute('disabled', 'disabled');
    };

    if (releasedDate || closedDate) {
      const formModalContent = this.formContent;

      this.blockSideBar();
      hideAddRemoveFilterFieldsButtons(formModalContent);
      disableFields(formModalContent);
      disableSaveButton(formModalContent);
    }
  }

  handlerToInformTheRuleAndTheGroupInTitle() {
    const ruleDescription = this.formContent.querySelector('.rules-description__selected');
    const eventsGroupEl = this.sideBar.querySelector(`[value="${this.state.when.value}"]`)?.parentNode?.previousSibling;

    if (this.state.when.label && ruleDescription && eventsGroupEl) {

      const when = Monet.I18n.getResourcesByKey('surveyApplyRule.modal.when').toLowerCase();
      const of = Monet.I18n.getResourcesByKey('surveyApplyRule.modal.of').toLowerCase();

      ruleDescription.innerHTML = ` ${when} <span>${this.state.when.label}</span> ${of} ${eventsGroupEl.innerHTML}`;
    }
  }

  blockSideBar = () => { this.sideBar.classList.add('blocked-overlay') };

  hideDeleteButtonsFromLookupList = () => {
    const { releasedDate, closedDate  } = Greenmile.Survey.Builder;

    if (releasedDate || closedDate) {
      const formModalContent = this.formContent;

      formModalContent
        .querySelectorAll('.container_lookuplist_added .del_item_added')
        .forEach(buttonsContainer => buttonsContainer.classList.add('display-none'));

      formModalContent
        .querySelectorAll('.container_lookuplist_added .power-lookup-list-remove-all-elements')
        .forEach(buttonsContainer => buttonsContainer.classList.add('display-none'));
    }

  };

  checkRuleListWithTriggersToShow(ruleList, ruleValue) {
    if (!ruleList?.items) {
      return ruleList;
    }

    const ruleListChecked = ruleList.items.filter(rule => {
      const triggersToShow = rule?.attributes?.triggersToShow;

      if (triggersToShow?.length) {
        const isToShow = triggersToShow.some(trigger => trigger === ruleValue);

        return isToShow;
      }

      return true;
    });

    return {
      items: ruleListChecked
    };
  }

  validatePopUp() {
    let isValid = true;
    const showErrorMessage = (resource) => {
      const monetMessage = new Monet.Form.Messages.InlineMessage();
      monetMessage.setScope("#SurveyApplyRules");
      monetMessage.setInfoType("error");
      monetMessage.setMessage({
        errorMessages: [Monet.Form.Messages.mountErrorMessageObject(resource)],
      });
      monetMessage.triggerMessage();
    };

    const eventTriggerIsEmpty = !this.checkEmptyEventTrigger();
    const existDuplicatedEventTrigger = !!this.checkDuplicateRule();
    const hasEmptyFiltersValues = this.checkEmptyFiltersValues();

    const errorController = [
      {
        isInvalid: eventTriggerIsEmpty,
        resourceMessage: 'Survey.notAddedAnyRule'
      },
      {
        isInvalid: existDuplicatedEventTrigger,
        resourceMessage: 'Survey.ruleAlreadyAdded'
      },
      {
        isInvalid: hasEmptyFiltersValues,
        resourceMessage: 'Survey.ApplyRulePopup.filtersAreEmpty'
      }
    ];

    errorController.forEach(errorData => {
      if (errorData.isInvalid && isValid) {
        isValid = false;
        showErrorMessage(errorData.resourceMessage);
      }
    });

    return isValid;
  }

  checkEmptyFiltersValues() {
    try {
      const handleSpecialCases = (hasFilterValueEmpty, rule) => {
        let hasEmptyFlag = hasFilterValueEmpty;
        const operators = Greenmile.Survey.SurveyApplyRule.operators;
        const fieldAttrIncludes = createIncludesTestTo(rule.value.field.attr);

        if (
          rule.value.operator === operators.yes.value ||
          rule.value.operator === operators.no.value ||
          fieldAttrIncludes([
            "Stop.orders.newOrder",
            "Order.delivered",
            "Order.canceled",
            "Order.damaged",
            "Order.partialDelivery",
          ])
        ) {
          hasEmptyFlag = false;
        }

        return hasEmptyFlag;
      };

      const filterIsEmpty = (rule) => {
        let hasFilterValueEmpty = false;
        const hasFieldEl = !!rule.value?.fieldEl;
        const fitlerValue = hasFieldEl && rule.value.fieldEl.getValue();

        if (hasFieldEl && !fitlerValue) {
          hasFilterValueEmpty = true;
        }

        hasFilterValueEmpty = handleSpecialCases(hasFilterValueEmpty, rule);

        return hasFilterValueEmpty;
      };

      const stateRulesMapToList = Array.from(this.state.rules, ([key, value]) => ({ key, value }));
      const hasEmpty = stateRulesMapToList.some(filterIsEmpty);

      return hasEmpty;

    } catch (error) {
      new Monet.Exception.ReturnError(this, "Trying check If has empty filter values.")
        .console();
    }
  }
}

export default ApplyRulePopup;
